export default "__VITE_ASSET__B0YoHD6L__"